import { Table, Tooltip } from "antd";
import { useContext, useEffect, useState } from "react";
import { RiFileExcel2Line } from "react-icons/ri";
import { AiOutlineSafetyCertificate } from "react-icons/ai";
import { SlReload } from "react-icons/sl";

import { LuPlus, LuShieldClose } from "react-icons/lu";

import { ExportToExcel } from "../../../utils/exportExcel";

import CreateRequest from "./components/CreateRequest";
import UploadSign from "./components/UploadSign";
import UpdateUser from "./components/UpdateUser";
import { useQuery } from "@tanstack/react-query";
import Something from "../../../components/shared/Something";
import ResetPassword from "./components/ResetPassword";
import UploadUsers from "./components/UploadUsers";
import {
  handleExportRequests,
  handleFetchRequests,
} from "../../../api/requests";
import formatMoney from "../../../utils/formatMoney";
import Moment from "react-moment";
import { useNavigate } from "react-router";
import { colors } from "../../../utils/data";
import getInitials from "../../../utils/getInitials";
import { AuthContext } from "../../../contexts/AuthContext";
import formatAccount from "../../../utils/formatAccount";

export default function Requests({ status }: any) {
  const { user, auth } = useContext(AuthContext);
  const [selected, setSelected] = useState<any>({});
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  const [resetModal, setResetModal] = useState<boolean>(false);
  const [signModal, setSignModal] = useState<boolean>(false);
  const [uploadModal, setUploadModal] = useState<boolean>(false);
  const [isExporting, setExporting] = useState<boolean>(false);

  const createAccess = [1, 9];

  const navigate = useNavigate();

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });

  const {
    data: requests,
    refetch,
    isLoading,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["requests", pagination.page, pagination.limit, status],
    queryFn: () =>
      handleFetchRequests({
        page: pagination.page,
        limit: pagination.limit,
        status: status || "",
      }),
  });

  const handlePageChange = (e: any) => {
    setPagination((prev: any) => ({
      ...prev,
      page: e.current,
      limit: e.pageSize,
    }));
  };
  const handleRefetch = () => {
    refetch();
  };

  const columns = [
    {
      title: "S/N",
      width: 40,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">
          {pagination?.page * pagination?.limit - pagination?.limit + index + 1}
        </span>
      ),
    },
    {
      title: "ACCOUNT",
      width: 80,
      render: (record: any) => {
        return (
          <div className="text-black text-center">
            {formatAccount(record?.customerAccount) || "-"}
          </div>
        );
      },
    },
    {
      title: "CUSTOMER NAME",
      width: 260,
      render: (record: any) => {
        return (
          <div className="text-gray-700">
            <div className="">{record?.customerName || "-"}</div>
          </div>
        );
      },
    },
    {
      title: "CURRENT LIMIT",
      width: 120,
      render: (record: any) => (
        <div className="text-gray-700 text-right">
          {formatMoney(record?.currentLimit)}
        </div>
      ),
    },
    {
      title: "REQUESTED LIMIT",
      width: 120,
      render: (record: any) => (
        <div className="text-blue-900 font-bold text-right">
          {formatMoney(record?.requestedLimit)}
        </div>
      ),
    },
    {
      title: "BUSINESS UNIT",
      width: 150,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.businessUnit?.name || "-"}
        </span>
      ),
    },
    {
      title: "REQUESTED BY",
      width: 110,
      render: (record: any) => (
        <span className="text-gray-700">{record?.createdBy?.name || "-"}</span>
      ),
    },
    {
      title: "REQUESTED",
      width: 110,
      render: (record: any) => (
        <span className="text-gray-700">
          <Moment fromNow>{record?.createdAt}</Moment>
        </span>
      ),
    },
    {
      title: "APPROVERS",
      width: 210,
      render: (record: any) => (
        <div className="flex justify-center">
          {record?.approvals?.lineManagers?.map((approver: any, index: any) => (
            <Tooltip placement="top" title={`${approver?.name}`} key={index}>
              <div
                className="text-white p-2 border flex justify-center items-center rounded-full  -mr-1"
                style={{
                  backgroundColor: `${colors[approver?.status] || "#9ca3af"}`,
                  fontSize: 8,
                }}
              >
                {getInitials(approver?.name)}
              </div>
            </Tooltip>
          ))}
          {record?.approvals?.businessUnitHeads?.map(
            (approver: any, index: any) => (
              <Tooltip placement="top" title={`${approver?.name}`} key={index}>
                <div
                  className="text-white p-2 border flex justify-center items-center rounded-full  -mr-1"
                  style={{
                    backgroundColor: `${colors[approver?.status] || "#9ca3af"}`,
                    fontSize: 8,
                  }}
                >
                  {getInitials(approver?.name)}
                </div>
              </Tooltip>
            )
          )}
          {record?.approvals?.financialControllers?.map(
            (approver: any, index: any) => (
              <Tooltip placement="top" title={`${approver?.name}`} key={index}>
                <div
                  className="text-white p-2 border flex justify-center items-center rounded-full  -mr-1"
                  style={{
                    backgroundColor: `${colors[approver?.status] || "#9ca3af"}`,
                    fontSize: 8,
                  }}
                >
                  {getInitials(approver?.name)}
                </div>
              </Tooltip>
            )
          )}
        </div>
      ),
    },
    {
      title: "EXECUTIVES",
      width: 120,
      render: (record: any) => (
        <div className="flex justify-center">
          {record?.approvals?.executives?.map((approver: any, index: any) => (
            <Tooltip placement="top" title={`${approver?.name}`} key={index}>
              <div
                className="text-white p-2 border flex justify-center items-center rounded-full  -mr-1"
                style={{
                  backgroundColor: "#3b82f6",
                  fontSize: 8,
                }}
              >
                {getInitials(approver?.name)}
              </div>
            </Tooltip>
          ))}
        </div>
      ),
    },
    {
      title: "STATUS",
      width: 120,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.isApproved ? (
            <div className="text-green-600 flex items-center">
              <div
                className="flex items-center"
                style={{ color: `${colors[record?.status] || "#9ca3af"}` }}
              >
                <AiOutlineSafetyCertificate size={18} />
                <span className="capitalize mx-1">{record?.status}</span>
              </div>
            </div>
          ) : (
            <div
              className="flex items-center"
              style={{ color: `${colors[record?.status] || "#9ca3af"}` }}
            >
              <LuShieldClose size={18} />
              <span className="capitalize mx-1">{record?.status}</span>
            </div>
          )}
        </span>
      ),
    },

    // {
    //   title: "ACTION",
    //   width: 100,
    //   render: (record: any) => (
    //     <div className="flex justify-end">
    //       <button
    //         onClick={() => {
    //           setSelected({
    //             ...record,
    //           });
    //         }}
    //         className="flex justify-center items-center text-gray-700 border rounded-md p-2 bg-yellow-100 hover:bg-yellow-200 cursor-not-allowed"
    //       >
    //         <FiEdit />
    //       </button>

    //       <button
    //         onClick={() => {
    //           setSelected({
    //             ...record,
    //           });
    //           setResetModal(true);
    //         }}
    //         className="flex justify-center items-center ml-1 text-gray-700 border rounded-md p-2 bg-gray-100 hover:bg-gray-200 cursor-pointer"
    //       >
    //         <LuLock />
    //       </button>

    //       <button
    //         onClick={() => {
    //           setSelected({
    //             ...record,
    //           });
    //         }}
    //         className="flex justify-center items-center ml-1 text-gray-700 border rounded-md p-2 bg-red-100 hover:bg-red-200 cursor-not-allowed"
    //       >
    //         <RiDeleteBinLine color="red" />
    //       </button>
    //     </div>
    //   ),
    // },
  ];

  const exportRequests = async () => {
    setExporting(true);
    const requests = await handleExportRequests();
    await ExportToExcel(
      requests?.map((item: any, index: number) => {
        return {
          "S/N": index + 1,
          Account: item?.customerAccount || "-",
          Customer: item?.customerName || "-",
          "Current Limit": formatMoney(item?.currentLimit) || "-",
          "Requested Limit": formatMoney(item?.requestedLimit) || "-",
          "Business Unit": item?.businessUnit?.name || "-",
          "Requested By": item?.createdBy?.name || "-",
          "Requested At": (
            <Moment format="DD/MM/YYYY">{item?.createdAt}</Moment>
          ),
          Status: item?.status || "-",
        };
      }),
      "Requests.xlsx"
    );
    setExporting(false);
  };

  useEffect(() => {
    setPagination({ ...pagination, total: requests?.total });
  }, [requests]);

  return (
    <div className="bg-gray-100">
      {/* <BackNav  /> */}
      <div className="bg-white m-1">
        <div className="flex flex-col sm:flex-row justify-between border-b p-2">
          <div className="">
            <div className="font-bold capitalize">
              {status || "All"} Requests
            </div>
            <div className="text-gray-600">Manage Request Details</div>
          </div>

          <div className="flex">
            <Tooltip title="Export To Excel">
              <button
                className="flex mx-2 justify-center items-center border px-4 h-8  hover:bg-gray-100"
                onClick={() => exportRequests()}
              >
                {isExporting ? <SlReload /> : <RiFileExcel2Line size={20} />}
              </button>
            </Tooltip>
            {createAccess.includes(auth?.accessLevel) && (
              <button
                onClick={() => setCreateModal(true)}
                className="flex mx-2 justify-center items-center border px-4 h-8  hover:bg-gray-100"
              >
                <LuPlus size={18} /> <span className="mx-2">New</span>
              </button>
            )}
          </div>
        </div>
        {isError ? (
          <Something refetch={refetch} isFetching={isFetching} />
        ) : (
          <div className="">
            <Table
              size="small"
              dataSource={requests?.records}
              columns={columns}
              scroll={{ y: 660, x: 0 }}
              rowKey="id"
              bordered
              pagination={{
                current: pagination?.page,
                pageSize: pagination?.limit,
                total: pagination?.total,
              }}
              onRow={(record: any) => {
                return {
                  onClick: () => {
                    navigate("/requests/" + record?._id);
                  },
                };
              }}
              rowClassName={"hover:bg-gray-100 cursor-pointer"}
              onChange={(e: any) => handlePageChange(e)}
              loading={isLoading}
            />
          </div>
        )}
      </div>

      <CreateRequest
        isVisible={createModal}
        setVisible={setCreateModal}
        refetch={handleRefetch}
      />

      <UpdateUser
        isVisible={updateModal}
        setVisible={setUpdateModal}
        refetch={refetch}
        selected={selected}
      />

      <UploadSign
        isVisible={signModal}
        setVisible={setSignModal}
        selected={selected}
        refetch={refetch}
      />

      <UploadUsers
        isVisible={uploadModal}
        setVisible={setUploadModal}
        selected={selected}
        refetch={refetch}
      />

      <ResetPassword
        isVisible={resetModal}
        setVisible={setResetModal}
        refetch={refetch}
        selected={selected}
      />
    </div>
  );
}
